document.addEventListener('DOMContentLoaded', function () {
    const cur = document.querySelector('.article-image[data-article-handle]');
    if (!cur) return;
    const currentHandle = cur.getAttribute('data-article-handle');

    const featured = document.querySelector('[data-featured-block]') ||
        document.querySelector('[data-featured-blog]');
    if (!featured) return;

    featured.querySelectorAll('[data-article-handle]').forEach(function (card) {
        if (card.getAttribute('data-article-handle') === currentHandle) {
            card.style.display = 'none';
        }
    });
});